module.exports = __webpack_public_path__ + "media/images/migration-105130ae253458e8006c093b0a3c7796.png";